import React from 'react'
import { AccordionHeader } from '../../../../../Components/Layout/Accordion'
import { PLL_IMAGES } from '../../../../../Config/config'
import { EVENTS_YEAR } from '../../../../../Config/League/league.config'

type HeaderParams = {
  rosterLength: number
}

export const ChampSeriesRosterHeader: React.FC<HeaderParams> = ({ rosterLength }) => {
  return (
    <AccordionHeader
      imgUrl={PLL_IMAGES.champSeriesLogo.webp}
      fallbackImg={PLL_IMAGES.champSeriesLogo.fallback}
      label={`${EVENTS_YEAR} CHAMPIONSHIP SERIES`}
      subText={`${rosterLength} Player Roster`}
    />
  )
}
